import React from 'react'
import { SearchBarProps } from '../../interfaces'
import styles from './styles.module.scss'

export const SearchBar: React.FC<SearchBarProps> = ({ searchText, onSearchChange }) => {
    return (
        <div className={styles.searchContainer}>
            <input
                type="text"
                placeholder="Search by title or tags..."
                value={searchText}
                onChange={(e) => onSearchChange(e.target.value)}
                className={styles.searchInput}
            />
        </div>
    )
}
